import React from "react";

function Disclaimer() {
  return (
    <div style={{ padding: "40px", maxWidth: 900, margin: "0 auto", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      
      <h1>Disclaimer</h1>

      <p>
        The information and services provided on <strong>ResumeFuel</strong> are for general informational 
        and career development purposes only. While we aim to provide helpful tools to create resumes 
        and CVs, we do not guarantee employment, interview calls, or job placement.
      </p>

      <h2>1. No Professional Advice</h2>
      <p>
        The resume templates, examples, and suggestions available on ResumeFuel are intended 
        to assist users in creating professional documents. They should not be considered 
        professional career, legal, or recruitment advice.
      </p>

      <h2>2. Accuracy of Information</h2>
      <p>
        We do not guarantee that all information, templates, or recommendations on this platform 
        are always complete, accurate, or up to date. Users are responsible for reviewing and 
        verifying the information they include in their resumes.
      </p>

      <h2>3. External Links</h2>
      <p>
        Our website may contain links to external websites or services. ResumeFuel is not 
        responsible for the content, policies, or practices of any third-party websites.
      </p>

      <h2>4. Limitation of Liability</h2>
      <p>
        ResumeFuel will not be liable for any losses, damages, or issues arising from the use 
        of our platform, including but not limited to job application outcomes or reliance 
        on the content provided.
      </p>

      <h2>5. User Responsibility</h2>
      <p>
        Users are solely responsible for the content they create and submit using our tools. 
        ResumeFuel is not responsible for any misuse of the platform.
      </p>

      <h2>6. Changes to This Disclaimer</h2>
      <p>
        We may update this Disclaimer at any time without prior notice. Any changes will be 
        posted on this page.
      </p>

      <h2>7. Contact</h2>
      <p>
        If you have any questions about this Disclaimer, please contact us.
      </p>

    </div>
  );
}

export default Disclaimer;